import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'partnership_coupon';

export default {
  async search(queryParams) {
    const url = mountUrl(`/${BASE_PATH}`, queryParams);
    return api.get(url);
  }
};
